import React from 'react';
import { Modal } from 'react-bootstrap';
import ModalHeader from 'components/Modal/ModalHeader';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import {
  hideApplySetItemModal,
  applySetItemItemsRequest,
} from 'actions/businessLibrary/modifier';
import Search from './Search';
import Items from './Items';
import styles from './ApplySetItemModal.css';

class ApplySetItemModal extends React.Component {
  render() {
    const {
      showApplySetItemModal,
      applySetItemItemsRequest,
      onHide,
    } = this.props;
    return (
      <Modal
        show={showApplySetItemModal}
        onHide={onHide}
        backdrop="static"
        dialogClassName={`modal-dialog ${styles.dialog}`}
      >
        <ModalHeader title={`Apply Set to Items`} />
        <form onSubmit={this.props.handleSubmit}>
          <Field component="input" type="hidden" name="id" />
          <Field component="input" type="hidden" name="itemIds" />
          <Modal.Body bsClass={`${styles.body} modal-body`}>
            <Search applySetItemItemsRequest={applySetItemItemsRequest} />
            <Items />
          </Modal.Body>
          <Modal.Footer>
            <span className="pull-left">
              <button
                type="button"
                className="btn btn-default"
                onClick={onHide}
              >
                Cancel
              </button>
            </span>
            <span className="pull-right">
              <button className="btn btn-primary">Apply to Items</button>
            </span>
            <span className="pull-right">
              <button
                className="btn btn-primary btn-apply-all"
                type="button"
                onClick={this.onClickApplyAll}
              >
                Apply to All Items
              </button>
            </span>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  onClickApplyAll = () => {
    const { values } = this.props.form;
    const { onClickApplyAll } = this.props;
    onClickApplyAll(values.id);
  };
}

function mapStateToProps(state) {
  const { showApplySetItemModal } = state.businessLibrary.modifierHub;
  const { applySetItem } = state.form;
  return { showApplySetItemModal, form: applySetItem };
}

const mapForm = {
  form: 'applySetItem',
};

const mapDispatchToProps = {
  onHide: hideApplySetItemModal,
  applySetItemItemsRequest,
};

export default reduxForm(mapForm)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ApplySetItemModal)
);
